/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { scopesControllerBulkArchive } from "./scopesControllerBulkArchive";
import { scopesControllerBulkDelete } from "./scopesControllerBulkDelete";
import { scopesControllerBulkMove } from "./scopesControllerBulkMove";

export function scopesService() {
  return { scopesControllerBulkMove, scopesControllerBulkDelete, scopesControllerBulkArchive }
}